import React, { useEffect } from "react";
import "./css/NewHomeComponents.css";
import NewMyCources from "./NewMyCources";
import NewHilites from "./NewHilites";
import NewAdImage from "./NewAdImage";
import NewHomeMenu from "./NewHomeMenu";
import { useLocation } from "react-router-dom";
import { allapiAction } from "../../Redux/common/action";
import { useDispatch, useSelector } from "react-redux";

const NewHomeComponents = () => {
  const dispatch = useDispatch();
  const locationv = useLocation();


   const get_product_list = useSelector((state) =>
    state?.allapi?.user_product_search ? state?.allapi?.user_product_search : {}
  );

  
  const listdata = get_product_list?.docs ? get_product_list?.docs : [];

  console.log(listdata);
  

  const searchParams = new URLSearchParams(locationv.search);
  const search = searchParams.get("search");
  const location = searchParams.get("location");
  const page = searchParams.get("page");

  const pageno = page ? page : 1;
  // useEffect(() => {
  //   // searchProduct

  //   if (search) {
  //     if (location) {
  //       dispatch(
  //         allapiAction.getDeducateListuserSide({
  //           page: pageno,
  //           id: search,
  //           location,
  //         })
  //       );
  //     } else {
  //       dispatch(
  //         allapiAction.getDeducateListuserSide({ page: pageno, id: search })
  //       );
  //     }
  //   } else {
  //     if (location) {
  //       dispatch(
  //         allapiAction.getDeducateListuserSide({ page: pageno, location })
  //       );
  //     } else {
  //       dispatch(allapiAction.getDeducateListuserSide({ page: pageno }));
  //     }
  //   }
  //   // dispatch(allapiAction.getfiltercategory({}));
  //   return () => {};
  // }, [locationv.search]);

  return (
    <div className="home">
      <NewHilites />

      <NewHomeMenu />

      <NewAdImage />

      <NewMyCources />
    </div>
  );
};

export default NewHomeComponents;
